var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:{faceDown:_vm.down, faceUp:_vm.up, faceLeft:_vm.left, faceRight:_vm.right},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.width,"viewBox":"0 0 16 16"}},[_c('path',{style:({ fill: _vm.fill }),attrs:{"d":"M.919 0 4.46 3.54 8 0l.919.919-4.459 4.46L0 .919z","transform":"translate(3.54 5.54)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }